import NidApp from "./api.js";

(function ($) {

	/* Globals */
	window.cp_mode = 'shortcode'; // this will be dynamic and set the use mode of the colour picker [ACF for backend, Product for WC Product, Moodboard and so on]
	window.cp_slugs = [];
	window.active_field_group = null;

	/**
	 * Load the colour picker for front end
	 */
	function product_load_modal() {
		var colour_picker = NidApp.jqueryPost({action: 'nid_get_colour_picker', product_id: nordsjo.postID});
		var colour_picker_content = $('#colour-picker-modal .colour-picker-container .colour-table');
		var colour_picker_modal = $('#colour-picker-modal');

		if (colour_picker_content.length === 0) {
			// load colour picker and enable filters
			NidApp.showLoadingIcon();
			$.when(colour_picker).done(function (colour_picker) {
					$('#colour-picker-modal .colour-picker-container').html(colour_picker.data);
					enable_colours();
					NidApp.removeLoadingIcon();
					colour_picker_modal.modal();
				}
			);
		} else {
			// if already loaded, just enable filters
			enable_colours();
			colour_picker_modal.modal();
		}
	}


	/**
	 * Loop through all swatches and enable the ones that are in the
	 * colour spaces set for the chosen product
	 */
	function enable_colours() {

		if (typeof nordsjo !== 'undefined' && typeof nordsjo.productColourSpaces !== 'undefined' && nordsjo.productColourSpaces.length !== 0) {
			window.cp_slugs = nordsjo.productColourSpaces;
		}

		if (window.cp_slugs.length === 0) {
			return;
		}

		var $swatches = $('.colour-swatch');
		$.each($swatches, function () {
			var $this = $(this);

			if (typeof $this.attr('data-colour-spaces') !== 'undefined') {
				var colour_spaces = $this.attr('data-colour-spaces').split(', ');

				var intersection = _.intersection(colour_spaces, window.cp_slugs);
				if (intersection.length > 0) {
					$this.attr('data-enabled', true);
				} else {
					$this.attr('data-enabled', false);
					$this.css('background-color', '#F0F0F0');
				}
			}
		});
	}


	/**
	 * Enable event watchers
	 */
	function enable_event_watchers() {

		/**
		 * event watcher for the main colour space selector
		 */
		$('body').on('click', '.colour-swatch', function (event) {

			var parent = $(this).closest('.colour-table');
			var row = $(this).closest('.colour-row');
			var selected_colours = $('.selected-colours');
			var colour = $(this).attr('data-colour');
			var nuance = $(this).attr('data-nuance');

			var first_x = parseInt($(this).attr('data-column'), 10);
			var first_y = parseInt($(this).attr('data-row'), 10);

			var column_count = parseInt(row.attr('data-column-count'), 10);
      if(isNaN(column_count)) {
        column_count = parseInt(parent.attr('data-column-count'), 10);
      }
			var row_count = parseInt(parent.attr('data-row-count'), 10);
			var parent_space = parent.attr('data-colour-space');

			var col, row, rgb;

			// reset the visible selection
			$('.colour-swatch').css('opacity', '1');
			$('.selected-colour-swatch').attr('data-selected', false);


			// We need to make sure that the selection box stays inside the grid
			if (first_x > column_count - 5) {
				first_x = column_count - 5;
			}

			if (first_y > row_count - 3) {
				first_y = row_count - 3;
			}

      console.log({first_x,first_y});
			// updating the selected colour matrix
			for (row = first_y; row < first_y + 3; row++) {
        console.log({row});
				for (col = first_x; col < first_x + 5; col++) {
          console.log({col});
					var $selectedColor = $('.colour-swatch[data-row="' + row + '"][data-column="' + col + '"]', parent);

					if ($selectedColor.length > 0) {
						var data = $selectedColor.data();
						var checked_swatch = $('.elements .chosen-swatch').clone();

						var fontColor = "black";
						if (data.swatch_tone === 'dark') {
							fontColor = "white";
						}

						$selectedColor.css('opacity', '0.5');

						var html = '<div class="swatch-data"><span class="colour-data">' + data.name + '</span></div>';
						if (data.enabled) {
							rgb = 'rgb(' + data.r + ', ' + data.g + ', ' + data.b + ')';
						} else {
							rgb = '#F0F0F0';
						}

						var css = {
							'background-color': rgb,
							'color': fontColor,
							'background-image': ''
						};

						if ( data.imageSmall ) {
							css["background-image"] = "url('" + data.imageSmall + "')";
						}

						$('.selected-colours-row[data-row=' + (row - first_y) + '] .selected-colour-swatch[data-color-col=' + (col - first_x) + ']')
							.html(html)
							.css( css )
							.attr('data-acc_code', data.acc_code)
							.attr('data-image-small', data.imageSmall)
							.attr('data-image-large', data.imageLarge)
							.attr('data-selected', $selectedColor.attr('data-selected'))
							.attr('data-enabled', data.enabled)
							.attr('data-parent-space', parent_space)
							.attr('data-id', data.id)
							.attr('data-name', data.name)
							.attr('data-r', data.r)
							.attr('data-g', data.g)
							.attr('data-b', data.b)
							.append(checked_swatch)
							.show();

					} else {
						$('.selected-colours-row[data-row=' + (row - first_y) + '] .selected-colour-swatch[data-color-col=' + (col - first_x) + ']').hide();
					}
				}
			}

			parent.append( selected_colours );
		});


		/**
		 * event watcher for the large swatches
		 */
		$('body').on('click', '.selected-colour-swatch', function (event) {

			var $this = $(this);

			var enabled = $this.attr('data-enabled');
			if (enabled == 'false') {
				return;
			}

			// get data and status from selected colour swatch
			var acc_code = $this.attr('data-acc_code');
			var selected = $this.attr('data-selected');
			var parent_space = $this.attr('data-parent-space');
			var post_id = $this.attr('data-id');
			var colour_name = $this.attr('data-name');
			var image_small = $this.attr('data-image-small');
			var image_large = $this.attr('data-image-large');
			var colour_r = $this.attr('data-r');
			var colour_g = $this.attr('data-g');
			var colour_b = $this.attr('data-b');
			var rgb = 'rgb(' + colour_r + ', ' + colour_g + ', ' + colour_b + ')';

			var parent = $('.colour-table[data-colour-space=' + parent_space + ']');

			// when the mode is shortcode, we need to update the swatch cart
			if (window.cp_mode === 'shortcode') {
				var new_state = false;
				if (selected == 'false') {
					new_state = 'true';
				}

				// set corresponding colour swatch from main selection as selected
				$('.colour-swatch[data-id="' + post_id + '"]', parent).attr('data-selected', new_state);
				update_cart();

				// mark this swatch as selected
				$this.attr('data-selected', new_state);
			}

			// when the mode is ACF we need to update the value of the ACF Field
			if (window.cp_mode === 'ACF') {
				update_acf_field(post_id, acc_code, rgb, colour_name);
				$('.colour_picker_acf').hide();
				$('.field_type-colour_picker[data-name=colour] .colour_swatch .delete', window.active_field_group).show();

			}

			// when the mode is Product we need to set the ACC-Code of the swatch to the product
			if (window.cp_mode === 'Product') {
				update_product_colour(acc_code, rgb, colour_name, image_small, image_large);
			}
		});


		/**
		 * event watcher for the ACF field color picker dialog
		 */
		$('body').on('click', '.colour-picker-close', function (event) {
			$('.colour_picker_acf').hide();
		});


		/**
		 * Event watcher for the selected colour swatches on product page
		 */
		$('body').on('click', '.colour-picker-product .colour_swatch', function (event) {
			var $this = $(event.currentTarget);
			var $container = $('<div />', {class: 'colour-swatch-modal modal fade', id: 'colour-swatch-modal'});
			$('<div />', {class: 'inner container'}).html($this.clone()).appendTo($container);
			$container.appendTo('.modal-d-container');
			$container.show();

			$container.on('click', function (e) {
				$(e.currentTarget).remove();
			});
		});


		/**
		 * Event watcher for the colour swatches in shoppinglist
		 */
		$('body').on('click', '.wishlist-prod-list .colour-card', function (event) {
			var $this = $(event.currentTarget);
			var $container = $('<div />', {class: 'colour-swatch-modal modal fade', id: 'colour-swatch-modal'});
			$('<div />', {class: 'inner container'}).html($this.clone()).appendTo($container);
			$container.appendTo('.modal-d-container');
			$container.show();

			$container.on('click', function (e) {
				$(e.currentTarget).remove();
			});
		});


		/**
		 * Event watcher for the colour swatches on colour picker page
		 */
		$('body').on('click', '#nid-colour-cart .colour', function (event) {
			var $this = $(event.currentTarget).parent();
			var $container = $('<div />', {class: 'colour-swatch-modal modal fade', id: 'colour-swatch-modal'});
			$('<div />', {class: 'inner container'}).html($this.clone()).appendTo($container);
			$container.appendTo('.modal-d-container');
			$container.show();

			$container.on('click', function (e) {
				$(e.currentTarget).remove();
			});
		});
	}

	/**
	 * Updates the selected colour swatches
	 */
	function update_cart() {
		var selected_colours = $('.colour-swatch[data-selected="true"]');

		// blank out the cart
		$('.colour-cart').html('');
		$('.nid-colour-cart-header .number-holder').html(0);
		$('.nid-colour-cart-header').hide();

		for (var i = 0; i < selected_colours.length; i++) {
			// clone a dummy swatch
			var $swatch = $('.sample-cart .swatch').clone();

			// get the data
			var acc_code = $(selected_colours[i]).attr('data-acc_code');
			var id = $(selected_colours[i]).attr('data-id');
			var colour_name = $(selected_colours[i]).attr('data-name');
			var enabled = $(selected_colours[i]).attr('data-enabled');
			var image_small = $(selected_colours[i]).attr('data-image-small');
			var image_large = $(selected_colours[i]).attr('data-image-large');

			var rgb = 'rgb(' + $(selected_colours[i]).attr('data-r') + ', ' + $(selected_colours[i]).attr('data-g') + ', ' + $(selected_colours[i]).attr('data-b') + ')';
			var css = { 'background-color': rgb, 'background-image': '' }
			if ( image_small ) {
				css["background-image"] = "url('" + image_large + "')";
			}

			// insert the data into the dummy swatch
			$($swatch).attr('data-acc_code', acc_code);
			$($swatch).attr('data-id', id);
			$('.swatch-delete', $swatch).attr('data-acc_code', acc_code);
			$('.swatch-delete', $swatch).attr('data-id', id);

			$('.moodboard-button', $swatch)
				.attr('data-acc_code', acc_code)
				.attr('data-color-colour_name', colour_name)
				.attr('data-text', colour_name + '<br>' + acc_code)
				.attr('data-type', 'colour')
				.attr('data-rgb', rgb);

			$('.name', $swatch).html(colour_name);
			$('.acc-code', $swatch).html(acc_code);
			$('.colour', $swatch).css( css );

			// append the swatch to the cart
			$('.colour-cart').append($swatch);
			var cart_count = $('.colour-cart li').length;
			if (cart_count > 0) {
				if (typeof(nordsjo) !== 'undefined') {
					if (cart_count > 1) {
						$('.nid-colour-cart-header .unit-holder').html(nordsjo.colourPlural);
					} else {
						$('.nid-colour-cart-header .unit-holder').html(nordsjo.colourSingle);
					}
				}
				$('.nid-colour-cart-header .number-holder').html(cart_count);
				$('.nid-colour-cart-header').show();
			}

			$('.moodboard-button', $swatch).on('click', NidApp.addItemToMoodboard);
		}

		/**
		 * add event watcher for deleting a swatch from cart
		 */
		$('.swatch-delete').on('click', function (event) {
			var id = $(this).attr('data-id');

			// deselect the colour from the swatch panes
			$('.colour-swatch[data-id="' + id + '"]').attr('data-selected', false);
			$('.selected-colour-swatch[data-id="' + id + '"]').attr('data-selected', false);

			// remove the deselected item from the cart
			update_cart();
		});

	}


	/**
	 * Set the colour variant for a WooCommerce Product
	 *
	 * @param acc_code
	 * @param rgb
	 * @param colour_name
	 * @param image_small
	 * @param image_large
	 */
	function update_product_colour(acc_code, rgb, colour_name, image_small = '', image_large = '') {
		var css = {
			'background-color': rgb,
			'background-image': "url('" + image_large + "')",
			'background-size': 'cover'
		}
		$('input[name=acc-code]').val(acc_code).trigger('change');
		$('#add-to-wishlist').attr('data-acc-code', acc_code).attr('data-rgb', rgb).attr('data-colour-name', colour_name).attr('data-image-small', image_small).attr('data-image-large', image_large);
		$('.colour_swatch').attr('data-acc-code', acc_code).attr('data-rgb', rgb).attr('data-colour-name', colour_name).attr('data-image-small', image_small).attr('data-image-large', image_large);
		$('#colour-picker-modal').modal('hide');
		$('.colour_swatch .swatch').css(css).show();
		$('.colour_swatch .name').html(colour_name).show();
	}


	/**
	 * Front end use
	 */
	$(document).ready(function () {

		/* product page */
		if ($('#product-colour-picker').length > 0) {
			window.cp_mode = 'Product';

			$('#product-colour-picker').on('click', function (e) {
					product_load_modal();
				}
			);
		}

		/* moodboard */
		if ($('#colorpicker-modal').length > 0) {
			window.cp_mode = 'Moodboard';
		}


		if (window.cp_mode === 'shortcode') {
			enable_colours();
			// set a default selection
			$('.colour-swatch').eq(0).click();
		}

		enable_event_watchers();

	});


}(jQuery));
